/* Sélecteur de couleur + ajout au panier maison — même DA que les configurateurs Elora,
   mais sans personnalisation : une seule unité, une seule option. */
(() => {
  const L_ = window.SVL_I18N || {};
  const V_ = (x) => (L_.vals && L_.vals[x]) || x;
  document.querySelectorAll("[data-svb]").forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = "true";

    const config = JSON.parse(root.querySelector("[data-config]").textContent);
    const t = config.strings;
    const piece = root.querySelector("[data-piece]");
    const form = root.querySelector("form");
    const button = root.querySelector("[data-submit]");
    const error = root.querySelector("[data-error]");
    let busy = false;

    const selectedVariant = () => {
      const color = piece.querySelector("[data-color][aria-pressed=true]").dataset.color;
      return config.variants.find((v) => v.option1 === color);
    };
    const showError = (message) => { error.textContent = message; error.hidden = false; };

    /* la galerie du thème suit la couleur choisie */
    const showMedia = (color) => {
      const variant = config.variants.find((v) => v.option1 === color);
      if (!variant || !variant.mediaId) return;
      const item = document.querySelector('[data-target$="-' + variant.mediaId + '"]');
      if (!item) return;
      (item.querySelector("button, a, [role=button]") || item).click();
    };

    const sync = () => {
      const v = selectedVariant();
      const note = piece.querySelector("[data-availability]");
      note.hidden = !v || v.available;
      note.textContent = t.unavailable;
      button.disabled = busy;
      button.textContent = busy ? t.busy : t.one;
    };

    piece.querySelectorAll("[data-color]").forEach((b) => b.addEventListener("click", () => {
      if (busy) return;
      piece.querySelectorAll("[data-color]").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      piece.querySelector("[data-color-label]").textContent = V_(b.dataset.color);
      error.hidden = true;
      sync();
      showMedia(b.dataset.color);
    }));

    const refreshDrawer = async (data) => {
      const drawer = document.querySelector("cart-drawer");
      if (!drawer || typeof drawer.renderContents !== "function") {
        window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
        return;
      }
      const ids = drawer.getSectionsToRender().map((s) => s.id);
      if (!data.sections || ids.some((id) => !data.sections[id])) {
        const r = await fetch(`${window.location.pathname}?sections=${ids.join(",")}`);
        data = { sections: await r.json() };
      }
      drawer.classList.remove("is-empty");
      drawer.renderContents(data);
      drawer.open();
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        const cart = await fetch((window.routes ? window.routes.cart_url : "/cart") + ".js").then((r) => r.json());
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "color-config", cartData: cart });
      }
    };

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (busy) return;
      error.hidden = true;
      const variant = selectedVariant();
      if (!variant || !variant.available) { showError(t.unavailable); return; }
      busy = true; sync();
      try {
        const drawer = document.querySelector("cart-drawer");
        const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
        const response = await fetch((window.routes ? window.routes.cart_add_url : "/cart/add") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections, sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || t.error);
        await refreshDrawer(data);
      } catch (e) {
        showError(e.message || t.error);
      } finally {
        busy = false; sync();
      }
    });

    sync();
  });
})();
